<style>
.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.innerBio {
  margin-left: auto;
  margin-right: auto;
  width: 1200px;
}

.transparent {
  opacity: 0.98;
}

.bg {
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: 0 0;
  background-size: contain;
}

.bio::-webkit-scrollbar {
  overflow: hidden; /* Hide scrollbars */
}

.scaleUp {
  transform: scale(2);
  transform-origin: left;
}
</style>
<template>
  <div id="bio" class="bio">
    <v-card v-if="loading" class="rounded-xl" elevation="7">
      <v-container class="text-center">
        <p class="text-lg-h4">Loading...</p>
      </v-container>
    </v-card>
    <v-card v-if="notFound" class="rounded-xl" elevation="7">
      <v-container class="text-center">
        <p class="text-lg-h4">This page could not be found.</p>
        <v-btn class="rounded-xl" to="/">Go Home</v-btn>
      </v-container>
    </v-card>
    <div
      v-if="!loading && !notFound"
      :style="`background: url(${
        '/i/' + bio.pageData.page.image
      }) no-repeat center center / cover; background-size: cover;`"
      class="outer bg"
    >
      <div class="middle">
        <div v-bind:class="{ innerBio: !$vuetify.breakpoint.mobile }">
          <v-row>
            <v-col>
              <v-card
                id="userCard"
                align="stretch"
                class="rounded-xl transparent"
                elevation="7"
              >
                <v-row>
                  <v-col md="4">
                    <v-container>
                      <div class="text-wrap">
                        <router-link
                          v-if="$store.state.user.username"
                          style="cursor: pointer; color: #2086ff"
                          tag="small"
                          to="/"
                        >
                          <v-icon color="#2086ff" small>mdi-arrow-left </v-icon>
                          Back to {{ $store.state.site.name }}
                        </router-link>
                        <div class="text-center">
                          <v-avatar
                            v-if="bio.user.avatar"
                            :src="'/i/' + bio.user.avatar"
                            size="200"
                          >
                            <v-img
                              v-if="bio.user.avatar"
                              :src="'/i/' + bio.user.avatar"
                              size="200"
                            ></v-img>
                          </v-avatar>
                          <v-avatar
                            v-if="!bio.user.avatar"
                            :src="
                              '/api/v1/userutils/identicon/' + bio.user.username
                            "
                            align="center"
                            class="text-center justify-center"
                            justify="center"
                            size="200"
                          >
                            <img
                              v-if="!bio.user.avatar"
                              :src="
                                '/api/v1/userutils/identicon/' +
                                bio.user.username
                              "
                            />
                          </v-avatar>
                          <p class="text-h6">
                            {{ bio.pageData.page.title }}
                          </p>
                          <p>
                            {{ bio.pageData.page.subtitle }}
                          </p>
                          <v-icon> mdi-eye</v-icon>
                          {{ bio.views }}
                        </div>
                      </div>
                    </v-container>
                  </v-col>
                  <v-col>
                    <div
                      class="text-block text-wrap"
                      style="white-space: pre-line; overflow-wrap: anywhere"
                    >
                      <v-container>
                        <p class="text-h6">About Me:</p>
                        <p class="text-pre-wrap">
                          {{ bio.pageData.page.content }}
                        </p>
                        <v-chip-group class="" column>
                          <v-chip
                            v-if="bio.pageData.page.social.twitter"
                            :href="
                              'https://twitter.com/' +
                              bio.pageData.page.social.twitter
                            "
                            class="ma-2"
                            color="#1DA1F2"
                          >
                            <v-icon> mdi-twitter</v-icon>&nbsp; Twitter
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.facebook"
                            :href="
                              'https://facebook.com/' +
                              bio.pageData.page.social.facebook
                            "
                            class="ma-2"
                            color="#4267B2"
                          >
                            <v-icon> mdi-facebook</v-icon>&nbsp; Facebook
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.matrix"
                            :href="
                              'https://matrix.to/#/' +
                              bio.pageData.page.social.matrix
                            "
                            class="ma-2"
                            color="#fffff"
                          >
                            <v-icon> mdi-matrix</v-icon>&nbsp; Matrix
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.youtube"
                            :href="
                              'https://youtube.com/channel/' +
                              bio.pageData.page.social.youtube
                            "
                            class="ma-2"
                            color="#c4302b"
                          >
                            <v-icon> mdi-youtube</v-icon>&nbsp; YouTube
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.website"
                            :href="bio.pageData.page.social.website"
                            class="ma-2"
                            color="primary"
                          >
                            <v-icon> mdi-earth</v-icon>&nbsp; Website
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.telegram"
                            :href="
                              'https://t.me/' +
                              bio.pageData.page.social.telegram
                            "
                            class="ma-2"
                            color="#0088cc"
                          >
                            <v-icon> mdi-send</v-icon>&nbsp; Telegram
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.teams"
                            :href="bio.pageData.page.social.teams"
                            class="ma-2"
                            color="#464EB8"
                          >
                            <v-icon> mdi-microsoft-teams</v-icon>&nbsp; Teams
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.discord"
                            class="ma-2"
                            color="#5865F2"
                          >
                            <v-icon> mdi-discord</v-icon>&nbsp;
                            {{ bio.pageData.page.social.discord }}
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.myspace"
                            :href="bio.pageData.page.social.myspace"
                            class="ma-2"
                            color="#1DA1F2"
                          >
                            <v-icon> mdi-myspace</v-icon>&nbsp; MySpace
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.linkedIn"
                            :href="
                              'https://linkedin.com/in/' +
                              bio.pageData.page.social.linkedIn
                            "
                            class="ma-2"
                            color="#0077B5"
                          >
                            <v-icon> mdi-linkedin</v-icon>&nbsp; LinkedIn
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.twitch"
                            :href="
                              'https://twitch.tv/' +
                              bio.pageData.page.social.twitch
                            "
                            class="ma-2"
                            color="#6441A5"
                          >
                            <v-icon> mdi-twitch</v-icon>&nbsp; Twitch
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.instagram"
                            :href="
                              'https://instagram.com/' +
                              bio.pageData.page.social.instagram
                            "
                            class="ma-2"
                            color="#DD2A7B"
                          >
                            <v-icon> mdi-instagram</v-icon>&nbsp; Instagram
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.github"
                            :href="
                              'https://github.com/' +
                              bio.pageData.page.social.github
                            "
                            class="ma-2"
                            color="white"
                            text-color="black"
                          >
                            <v-icon> mdi-github</v-icon>&nbsp; GitHub
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.bitbucket"
                            :href="
                              'https://bitbucket.com/' +
                              bio.pageData.page.social.bitbucket
                            "
                            class="ma-2"
                            color="#1A74ED"
                          >
                            <v-icon> mdi-bitbucket</v-icon>&nbsp; BitBucket
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.gitlab"
                            :href="
                              'https://gitlab.com/' +
                              bio.pageData.page.social.gitlab
                            "
                            class="ma-2"
                            color="#E2432A"
                          >
                            <v-icon> mdi-gitlab</v-icon>&nbsp; GitLab
                          </v-chip>
                          <v-chip
                            v-if="bio.pageData.page.social.gitea"
                            :href="bio.pageData.page.social.gitea"
                            class="ma-2"
                            color="#6ba035"
                          >
                            <v-icon> mdi-tea</v-icon>&nbsp; Gitea
                          </v-chip>
                        </v-chip-group>
                      </v-container>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "Bio",
  data() {
    return {
      loading: true,
      notFound: false,
      heightAbout: 0,
      divideHeightAbout: 0,
      heightInfo: 0,
      divideHeightInfo: 0,
      bio: {
        stats: {},
        pageData: {},
        user: {
          username: "Loading...",
          avatar: "loading"
        }
      }
    }
  },
  methods: {
    view() {
      this.axios.put("/api/v1/bios/view/" + this.$route.params.username)
    },
    getBio() {
      this.loading = true
      this.axios
        .get("/api/v1/bios/get/" + this.$route.params.username)
        .then((res) => {
          this.bio = res.data
          this.bio.pageData = JSON.parse(res.data.pageData)
          this.loading = false
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
          this.loading = false
          this.notFound = true
        })
    }
  },
  mounted() {
    this.getBio()
    this.view()
  }
}
</script>

<style scoped></style>
